/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-nested-ternary */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, Box, Checkbox, Divider, FormControl, FormControlLabel, Paper, TextField, Tooltip, CircularProgress } from '@mui/material';

import schemedefinationService from '../../../services/schemedefination.service';
import LoadingProgressBar from '../../../components/loading-progressbar/loadingprogressbar';



const custom1 = ({
    value, options, handleOnChange,
    ...paperProps
}) => {
    const { children, ...restPaperProps } = paperProps;
    return (
        <Paper {...restPaperProps}>

            <Box onMouseDown={(e) => e.preventDefault()} sx={{ display: 'flex', height: '2rem', alignItems: 'center', paddingLeft: '2.142em' }}>

                <FormControlLabel
                    onClick={(e) => {
                        e.preventDefault(); // prevent blur

                        const allValues = options;

                        if (value?.length < allValues.length) {
                            // Select all items
                            handleOnChange(allValues);
                        } else {
                            // Unselect all items
                            handleOnChange([]);

                        }
                    }}
                    label={
                        <span style={{ fontSize: '13px', paddingLeft: '0.7em' }}>
                            {value?.length === options?.length ? 'Unselect All' : 'Select All'}
                        </span>
                    } control={
                        <Checkbox size='small' id="select-all-checkbox" checked={options.length > 0 && value?.length === options?.length} />
                    }
                />
            </Box>
            <Divider />
            {children}
        </Paper>
    );

}


const custom2 = ({
    fullData, classificationName, searchedValue, value, handleOnChange,
    ...paperProps
}) => {
    const { children, ...restPaperProps } = paperProps;

    const defaultValues = fullData[classificationName]?.DefaultValues || [];
    const displayKey = fullData[classificationName]?.DisplayExpr;
    const valueKey = fullData[classificationName]?.ValueExpr;

    // Normalize value to always be an array of objects
    const currentValue = (() => {
        if (!Array.isArray(value)) return [];

        // If value contains strings (IDs), convert to objects
        if (typeof value[0] === 'string') {
            return defaultValues.filter(item =>
                value.includes(item[valueKey])
            );
        }

        // If already objects, return as is
        return value;
    })();

    // Filtered options for search
    const filteredOptions = defaultValues.filter(item => {
        const displayVal = item[displayKey];
        return displayVal?.toLowerCase().includes(searchedValue.toLowerCase());
    });

    // Check if ALL filtered are selected
    const isAllFilteredSelected =
        filteredOptions.length > 0 &&
        filteredOptions.every(filtered =>
            currentValue.some(selected =>
                selected[valueKey] === filtered[valueKey]
            )
        );

    // Determine checkbox state
    const isAllSelected = searchedValue.length > 0
        ? isAllFilteredSelected
        : currentValue.length === defaultValues.length;

    const handleToggleClick = (e) => {
        e.preventDefault();

        if (searchedValue.length > 0) {
            if (isAllFilteredSelected) {
                // Unselect only filtered ones
                const newValues = currentValue.filter(
                    item => !filteredOptions.some(
                        filtered => filtered[valueKey] === item[valueKey]
                    )
                );
                handleOnChange(newValues);
            } else {
                // Select filtered without duplicates
                const mergedValues = [
                    ...currentValue,
                    ...filteredOptions.filter(
                        fo => !currentValue.some(cv => cv[valueKey] === fo[valueKey])
                    )
                ];
                handleOnChange(mergedValues);
            }
        } else {
            // Toggle Select All / Unselect All
            // eslint-disable-next-line no-lonely-if
            if (currentValue.length < defaultValues.length) {
                handleOnChange(defaultValues);
            } else {
                handleOnChange([]);
            }
        }
    };

    return (
        <Paper {...restPaperProps}>
            <Box
                onMouseDown={(e) => e.preventDefault()}
                sx={{ display: 'flex', height: '2rem', alignItems: 'center', paddingLeft: '2.142em' }}
            >
                <FormControlLabel
                    onClick={handleToggleClick}
                    label={
                        <span style={{ fontSize: '13px' }}>
                            {searchedValue.length > 0
                                ? isAllFilteredSelected
                                    ? 'Unselect filtered options'
                                    : 'Select filtered options'
                                : currentValue.length === defaultValues.length
                                    ? 'Unselect All'
                                    : 'Select All'
                            }
                        </span>
                    }
                    control={
                        <Checkbox
                            size='small'
                            id="select-all-checkbox"
                            checked={isAllSelected}
                        />
                    }
                />
            </Box>
            <Divider />
            {children}
        </Paper>
    );
};




const RetailerValueEditor = ({ handleOnChange, value, field }) => {
    const [loading, setLoading] = useState(false);
    const [subClassificationData, setSubClassificationData] = useState({}); // NOSONAR
    const [fullData, setFullData] = useState({});
    const classificationName = field ? field.split('-')[1] : '';
    const [dataTypes, setDataTypes] = useState({});
    const [options, setOptions] = useState([]);
    const [searchedValue, setSearchedValue] = useState('');  // NOSONAR
    const [AutocompleteLoadingMap, setAutocompleteLoadingMap] = useState(new Map());













    useEffect(() => {
        const getFirstSubClassification = async () => {
            setOptions([]); // Clear stale options from previous classification
            setSearchedValue(''); // Clear search text for new classification
            setLoading(true);
            try {
                const payload = {
                    filterApplicationOn: 'Retailer',
                    filterClassification: classificationName,
                    IsException: false,
                    SchemeId: 0,
                };

                if (classificationName === '') {
                    return;
                }
                const schemeDefinationInstance = await schemedefinationService;
                const response = await schemeDefinationInstance.GetSchemeFilterSubClassificationRetailer(payload);

                if (response.status === 200) {

                    

                    setFullData((prevData) => ({
                        ...prevData,
                        [classificationName]: response.data,
                    }))
                    setSubClassificationData((prevData) => ({
                        ...prevData,
                        [classificationName]: response.data?.DefaultValues,
                    }));

                    setDataTypes((prevData) => ({
                        ...prevData,
                        [classificationName]: response.data?.DataType || '',
                    }));

                    // Populate options with selected values and default values
                    try {
                        const defaultVals = response.data?.DefaultValues || [];
                        const valueKey = response.data?.ValueExpr;
                        const displayKey = response.data?.DisplayExpr;

                        let initialOptions = [];
                        if (Array.isArray(value) && value.length > 0) {
                            initialOptions = value.map(val => {
                                if (typeof val === "object" && val !== null) return val;
                                const found = defaultVals.find(item =>
                                    (valueKey && item[valueKey] === val) || (displayKey && item[displayKey] === val)
                                );
                                if (found) return found;
                                const vKey = valueKey || classificationName;
                                const dKey = displayKey || classificationName;
                                return { [vKey]: val, [dKey]: val };
                            });
                        }

                        setOptions(initialOptions);
                    } catch (error_) {
                        console.log("err: ", error_);
                    }
                } else {
                    console.error('Error while fetching subclassification data. Status:', response.status, 'Error Message:', response.data);
                }
            } catch (error) {
                console.error('Error:', error);
            } finally {
                setLoading(false);
            }
        };

        getFirstSubClassification();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classificationName]);

    // Keep options updated if value arrives or changes with items not yet in options
    useEffect(() => {
        if (Array.isArray(value) && value.length > 0 && fullData[classificationName]) {
            const valueKey = fullData[classificationName]?.ValueExpr;
            const displayKey = fullData[classificationName]?.DisplayExpr;
            const defaultVals = fullData[classificationName]?.DefaultValues || [];

            setOptions(prevOptions => {
                const existingIds = new Set(prevOptions.map(item => (valueKey && item[valueKey]) || Object.values(item)[0]));
                const missing = [];

                value.forEach(val => {
                    const valId = typeof val === "string" ? val : ((valueKey && val[valueKey]) || Object.values(val)[0]);
                    if (valId && !existingIds.has(valId)) {
                        if (typeof val === "object" && val !== null) {
                            missing.push(val);
                        } else {
                            const inDefault = defaultVals.find(item =>
                                (valueKey && item[valueKey] === val) || (displayKey && item[displayKey] === val)
                            );
                            if (inDefault) {
                                missing.push(inDefault);
                            } else {
                                const vKey = valueKey || classificationName;
                                const dKey = displayKey || classificationName;
                                missing.push({ [vKey]: val, [dKey]: val });
                            }
                        }
                    }
                });

                if (missing.length > 0) {
                    return [...missing, ...prevOptions];
                }
                return prevOptions;
            });
        }
    }, [value, classificationName, fullData]);

    const getSelectedItems = () => {
        if (!Array.isArray(value) || value.length === 0) return [];

        const valueKey = fullData[classificationName]?.ValueExpr;
        const displayKey = fullData[classificationName]?.DisplayExpr;
        const defaultVals = fullData[classificationName]?.DefaultValues || [];

        return value.map(val => {
            if (typeof val === "object" && val !== null) {
                return val;
            }
            const inDefault = defaultVals.find(item =>
                (valueKey && item[valueKey] === val) || (displayKey && item[displayKey] === val)
            );
            if (inDefault) return inDefault;

            const inOptions = options.find(item =>
                (valueKey && item[valueKey] === val) || (displayKey && item[displayKey] === val)
            );
            if (inOptions) return inOptions;

            const vKey = valueKey || classificationName;
            const dKey = displayKey || classificationName;
            return { [vKey]: val, [dKey]: val };
        });
    };

    const isOptionSelected = (option) => {
        if (!Array.isArray(value) || value.length === 0) return false;
        const valueKey = fullData[classificationName]?.ValueExpr;
        const optVal = (valueKey && option[valueKey]) || Object.values(option)[0];

        return value.some(v => {
            if (typeof v === "string") {
                return v === optVal;
            }
            if (typeof v === "object" && v !== null) {
                const vVal = (valueKey && v[valueKey]) || Object.values(v)[0];
                return vVal === optVal || v === option;
            }
            return false;
        });
    };

    if (dataTypes[classificationName] === "Autocomplete") {
        return (
            <FormControl fullWidth>
               

                <Autocomplete
                    key={classificationName}
                    freeSolo
                    forcePopupIcon
                    multiple
                    disabled={classificationName === ''}
                    fullWidth
                    disableCloseOnSelect
                    inputValue={searchedValue}
                    options={classificationName !== '' ? (Array.isArray(options) ? options : []) : []} // Use filtered options
                    filterOptions={(x) => x} // Disable client-side filtering; options come from server search
                    getOptionLabel={(option) => {
                        if (typeof option === "string") return option;
                        const displayKey = fullData[classificationName]?.DisplayExpr;
                        return (displayKey && option[displayKey]) || Object.values(option)[0] || "";
                    }}
                    isOptionEqualToValue={(option, val) => {
                        if (!option || !val) return false;
                        if (option === val) return true;
                        const valueKey = fullData[classificationName]?.ValueExpr;
                        const optVal = (valueKey && option[valueKey]) || Object.values(option)[0];
                        const vVal = typeof val === "string" ? val : ((valueKey && val[valueKey]) || Object.values(val)[0]);
                        return Boolean(optVal && vVal && optVal === vVal);
                    }}
                    value={getSelectedItems()}
                    onChange={(event, newValue, reason) => {
                        if (!(reason === 'removeOption' && event.type === 'keydown')) {
                            handleOnChange(newValue);
                        }
                    }}
                    renderTags={(selected) => (
                        <span style={{ paddingLeft: '8px', fontSize: '13px' }}>
                            {selected.length === 1 ? `${selected.length} item selected` : `${selected.length} items selected`}
                        </span>
                    )}
                    slots={{
                        paper: custom1,
                    }}
                    slotProps={{
                        paper: {
                            options,
                            handleOnChange,
                            value: getSelectedItems(),
                        },
                    }}
                    PaperComponent={custom1}
                    loading={AutocompleteLoadingMap.get(fullData[classificationName]?.ValueExpr)}
                    renderInput={(params) => (
                        <Tooltip
                            title={
                                <div
                                    style={{
                                        maxHeight: '150px',
                                        overflowY: value?.length > 3 ? 'auto' : 'hidden', // Show scrollbar only if there are more than 3 items
                                    }}
                                >
                                    <span
                                        style={{
                                            color: '#9e9e9e',
                                            fontSize: '12px',
                                            fontWeight: '300',
                                        }}
                                    >
                                        {getSelectedItems().map((item) => {
                                            const displayKey = fullData[classificationName]?.DisplayExpr;
                                            return (displayKey && item[displayKey]) || Object.values(item)[0] || "";
                                        }).join(", ") || "No items selected"}
                                    </span>
                                </div>
                            }
                            arrow
                            placement="top"
                            PopperProps={{
                                sx: {
                                    '& .MuiTooltip-tooltip': {
                                        backgroundColor: 'white', // White background
                                        color: 'black', // Black text
                                        border: '1px solid #ccc', // Optional: subtle border for better visibility
                                        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25)',
                                    },
                                    '& .MuiTooltip-arrow': {
                                        color: '#f9f9f9', // Match the arrow color with the tooltip background
                                    },
                                    display: value?.length === 0 || value === undefined || value === null ? 'none' : '', // Fix conditional syntax
                                },
                            }}
                        >

                            <TextField
                                {...params}
                                fullWidth
                                size="small"
                                label={`Select ${classificationName ? classificationName.toLowerCase() : ''}`.trim() || 'Select value'}

                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {AutocompleteLoadingMap.get(fullData[classificationName]?.ValueExpr) ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                                sx={{
                                    '& .MuiInputBase-input': {
                                        fontSize: '13px',  // Set text size to 13px
                                    },
                                    '& .MuiFormLabel-root': {
                                        fontSize: '14px',  // Set label text size to 14px
                                    },
                                }}
                            />
                        </Tooltip>
                    )}
                    onInputChange={async (event, newInputValue, reason) => {   // NOSONAR
                        if (reason === 'input') {
                            setSearchedValue(newInputValue);
                            const minSearchLength = classificationName === 'CHEERSCODE' ? 5 : 3;
                            if (newInputValue.length >= minSearchLength) {
                                setLoading(true);
                                try {
                                    const schemeDefinationInstance = await schemedefinationService;
                                    setAutocompleteLoadingMap(prev => new Map(prev).set(fullData[classificationName]?.ValueExpr, true));

                                    const response = await schemeDefinationInstance.autocompleteSearchFilter(
                                        {
                                            "ControlId": `${fullData[classificationName]?.TableName}-${fullData[classificationName]?.DisplayExpr}`,
                                            "Values": newInputValue,
                                        }
                                    );
                                    setAutocompleteLoadingMap(prev => {
                                        const newMap = new Map(prev);
                                        newMap.delete(fullData[classificationName]?.ValueExpr);
                                        return newMap;
                                    });
                                    if (response.data && Array.isArray(response.data)) {
                                        setOptions(() => {
                                            const valueKey = fullData[classificationName]?.ValueExpr;
                                            const currentSelected = getSelectedItems();
                                            const selectedIdSet = new Set(
                                                currentSelected.map(item => (valueKey && item[valueKey]) || Object.values(item)[0])
                                            );

                                            // Filter new options by checking if their IDs are not already selected
                                            const newOptions = response.data.filter(newItem => {
                                                const newId = (valueKey && newItem[valueKey]) || Object.values(newItem)[0];
                                                return newId && !selectedIdSet.has(newId);
                                            });

                                            return [...currentSelected, ...newOptions];
                                        });
                                    } else {
                                        console.error("Invalid response data: ", response);
                                    }
                                } catch (err) {
                                    setAutocompleteLoadingMap(prev => {
                                        const newMap = new Map(prev);
                                        newMap.delete(fullData[classificationName]?.ValueExpr);
                                        return newMap;
                                    });
                                } finally {
                                    setLoading(false);
                                }
                            } else {
                                setOptions(getSelectedItems());
                            }
                        } else if (reason === 'clear') {
                            setSearchedValue('');
                            setOptions(getSelectedItems());
                        }
                    }}
                    renderOption={(props, option) => {
                        const displayKey = fullData[classificationName]?.DisplayExpr;
                        const label = (displayKey && option[displayKey]) || Object.values(option)[0] || "";
                        return (
                            <li {...props} style={{ fontSize: "13px" }}>
                                <Checkbox
                                    style={{ marginRight: 8 }}
                                    checked={isOptionSelected(option)}
                                    size="small"
                                />
                                {label}
                            </li>
                        );
                    }}
                    size="small"
                    sx={{
                        maxHeight: '35.69px'
                    }}
                />
            </FormControl>
        );
    }

    if (dataTypes[classificationName] === "MultiselectDropdown") {
        return (
            <FormControl fullWidth size='small'>

                <Autocomplete
                    multiple
                    key={classificationName}
                    fullWidth
                    size="small"
                    disabled={classificationName === ''}
                    value={(() => {
                        // If value is an array of strings (IDs), convert to objects
                        if (Array.isArray(value) && typeof value[0] === 'string' && fullData[classificationName]) {
                            return fullData[classificationName]?.DefaultValues?.filter(item => {
                                const idKey = Object.keys(item).find(key => key.toLowerCase().includes('id'));
                                return idKey && value.includes(item[idKey]);
                            }) || [];
                        }
                        // If value is already an array of objects, return as is
                        return value || [];
                    })()}
                    inputValue={searchedValue} // Match with the setter
                    onInputChange={(event, newInputValue, reason) => {
                        if (reason === 'input') {
                            setSearchedValue(newInputValue);
                        }
                    }}
                    onChange={(event, newValue, reason) => {
                        if (!(reason === 'removeOption' && event.type === 'keydown')) {
                            handleOnChange(newValue);
                        }
                    }}
                    options={fullData[classificationName]?.DefaultValues || []}
                    getOptionLabel={(option) => {
                        const label = Object.keys(option).find(key => !key.toLowerCase().includes('id'));
                        return option[label];
                    }}
                    isOptionEqualToValue={(option, valuee) => {
                        if (!option || !valuee) {
                            return false; // or handle the case where either is undefined/null
                        }
                        const valueKey = Object.keys(valuee).find(key => key.toLowerCase().includes('id'));
                        const optionKey = Object.keys(option).find(key => key.toLowerCase().includes('id'));
                        return valuee[valueKey] === option[optionKey];
                    }}
                    slots={{
                        paper: custom2,
                    }}
                    slotProps={{
                        paper: {
                            fullData, classificationName, searchedValue, value, handleOnChange,
                        },
                    }}
                    PaperComponent={custom2}
                    disableCloseOnSelect
                    renderOption={(props, option, { selected }) => {
                        const label = Object.keys(option).find(key => !key.toLowerCase().includes('id'));

                        return (
                            <li {...props} style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                <Checkbox
                                    checked={selected}
                                    sx={{ fontSize: '13px' }}
                                    size='small'
                                />
                                {option[label]}
                            </li>
                        );
                    }}
                    // onBlur={() => setSearchedValue('')}
                    renderInput={(params) => (
                        <Tooltip
                            title={
                                <div
                                    style={{
                                        maxHeight: '150px',
                                        overflowY: value?.length > 3 ? 'auto' : 'hidden', // Show scrollbar only if there are more than 3 items
                                    }}
                                >
                                    <span
                                        style={{
                                            color: '#9e9e9e',
                                            fontSize: '12px',
                                            fontWeight: '300',
                                        }}
                                    >
                                        {(Array.isArray(value) && typeof value[0] === 'string' && fullData[classificationName] ? fullData[classificationName]?.DefaultValues?.filter(item => {
                                            const idKey = Object.keys(item).find(key => key.toLowerCase().includes('id' || 'Id'));

                                            return idKey && value?.includes(item[idKey]);
                                        }) : value || []).map((item) => {
                                            const labelKey = Object.keys(item).find(key => !key.toLowerCase().includes('id'));
                                            return item[labelKey];
                                        }).join(', ') || 'No items selected'}
                                    </span>
                                </div>
                            }
                            arrow
                            placement="top"
                            PopperProps={{
                                sx: {
                                    '& .MuiTooltip-tooltip': {
                                        backgroundColor: 'white', // White background
                                        color: 'black', // Black text
                                        border: '1px solid #ccc', // Optional: subtle border for better visibility
                                        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25)',
                                    },
                                    '& .MuiTooltip-arrow': {
                                        color: '#f9f9f9', // Match the arrow color with the tooltip background
                                    },
                                    display: value?.length === 0 || value === null || value === undefined ? 'none' : '', // Fix conditional syntax
                                },
                            }}
                        >

                            <TextField
                                {...params}
                                // placeholder="Select Value"
                                label={`Select ${classificationName ? classificationName.toLowerCase() : ''}`.trim() || 'Select value'}
                                // value={searchedValue}
                                // onChange={e => setSearchedValue(e.target.value)}
                                sx={{
                                    '& .MuiInputBase-input': {
                                        fontSize: '13px',  // Set text size to 13px
                                    },
                                    '& .MuiFormLabel-root': {
                                        fontSize: '14px',  // Set label text size to 14px
                                    },
                                }}
                            />
                        </Tooltip>
                    )}
                    renderTags={(selected, getTagProps) => {
                        const selectedCount = selected.length;
                        return (
                            <span style={{ fontSize: '13px', paddingLeft: '0.5em' }}>
                                {selectedCount === 1
                                    ? `${selectedCount} item selected`
                                    : `${selectedCount} items selected`}
                            </span>
                        );
                    }}

                    sx={{ fontSize: '13px' }}
                    PaperProps={{
                        style: {
                            maxHeight: 200,
                            maxWidth: 250,
                        },
                    }}
                    ListboxProps={{
                        style: {
                            maxHeight: '224px',
                            '& .MuiAutocomplete-option': {
                                fontSize: '13px',  // Set the font size for the options
                            },
                        },
                    }}
                />
                {
                    loading && <LoadingProgressBar />
                }
            </FormControl>
        );
    }

    return <FormControl fullWidth size='small'>
        <TextField
            fullWidth
            size="small"
            label={`Enter ${classificationName ? classificationName.toLowerCase() : 'value'}`.trim() || 'Select value'}
            disabled={classificationName === '' || loading}
            placeholder="Select value"
            sx={{
                '& .MuiInputBase-input': {
                    fontSize: '13px',
                },
                '& .MuiFormLabel-root': {
                    fontSize: '14px',
                },
            }}
        />
        {loading && <LoadingProgressBar />}
    </FormControl>;
};

RetailerValueEditor.propTypes = {
    handleOnChange: PropTypes.func.isRequired,
    value: PropTypes.array,
    field: PropTypes.object.isRequired,
};

export default RetailerValueEditor;